<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>카테고리</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{totalCount}}</span></strong> 건
        </div>

        <div class="ml-auto p-2">
          <button type="button" class="btn mint" @click="goEdit('NEW')">+ 새 카테고리 추가</button>
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="filterText" placeholder="카테고리명">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <!-- <div class="p-2 search-detail">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div> -->
      </div>

    <div :style="treeStyle" v-loading="searchLoading" class="mt-3">
      <el-tree ref="tree" :data="treeData" :default-expanded-keys="defaultExpanded" node-key="value" :filter-node-method="filterNode">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="el-tree-node__label">{{ node.label }}</span>
          <span>
            <el-button type="text" size="mini" @click="() => goEditTree(data)">상세</el-button>
          </span>
        </span>
      </el-tree>
    </div>
    </div>

     <!-- <el-collapse-transition>
        <div v-show="show">
          <el-cascader
            :options="options"
            v-model="selectedOptions"
            separator=">"
            filterable
            change-on-select
            @change="handleChange">
          </el-cascader>
        </div>
      </el-collapse-transition> -->

    <!-- <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      :action-col="actionCol"
      @row-click="rowClickHandler">
    </stone-data-table>
    <div class="ml-auto p-2">
      <button type="button" class="btn mint" @click="selectedTree">test</button>
    </div> -->
    <!-- <el-tree
          :data="treeData"
          ref="tree"
          :show-checkbox="false"
          node-key="value"
          default-expand-all
          :expand-on-click-node="false">
        </el-tree> -->

  </div>
</template>
<script>
import common from '@/modules/common'
export default {
  name: 'M990401',
  mixins: [common.mixins],
  data () {
    return {
      show: false,
      tableData: [],
      treeData: [],
      tableColumns: [
        {label: '카테고리코드', prop: 'cate_code', align: 'left', class: 'bold'},
        {label: '카테고리명', prop: 'kor_name', align: 'left'},
        {label: '상위 카테고리명', prop: 'parent_name'},
        {label: '경로', prop: 'path', align: 'left'}
      ],
      actionCol: {
        label: '삭제',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.deleteCategory(row.cate_code, row.parent_code, row.is_leaf)
          },
          props: {
            type: 'danger',
            size: 'mini',
            icon: 'el-icon-delete'
          },
          label: '삭제'
        }]
      },
      search: {
        name: '',
        depth: 1
      },
      options: [],
      selectedOptions: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      defaultExpanded: [],
      filterText: '',
      treeStyle: 'overflow-y: scroll;',
      totalCount: 0
    }
  },
  beforeCreate () {
  },
  created () {
    // if (this.$route.params.isSearch) {
    // }
    // initial parent list
    // this.getParentList()
    const treeHeight = this.getScreenHeight(-68)
    // console.log('treeHeight : ', treeHeight)
    this.treeStyle += (' height: ' + treeHeight + 'px;')
    this.retrieve()
  },
  mounted () {
  },
  methods: {
    retrieve () {
      // this.loadStoneDataTable('/category/tree', this.search)
      //   .then(response => {
      //     this.tableData = response.data
      //   })
      this.searchLoading = true
      common.axios.get('/category/tree/code')
        .then(response => {
          this.treeData = response.data
          this.defaultExpanded = []
          this.treeData.forEach(item => {
            this.defaultExpanded.push(item.value)
          })
          this.totalCount = this.getNodeCount(this.treeData)
          this.searchLoading = false
        })
        .catch(() => {
          this.searchLoading = false
        })
    },
    getNodeCount (data) {
      let count = 0
      data.forEach(x => {
        count++
        if (x.children) {
          count += this.getNodeCount(x.children)
        }
      })
      return count
    },
    goEdit (cateCode) {
      const param = {
        cate_code: cateCode
      }
      this.$router.push({name: 'M990402', params: param})
    },
    rowClickHandler (row, event, column) {
      this.goEdit(row.cate_code)
    },
    deleteCategory (codeCode, parentCode, isLeaf) {
      this.$confirm('삭제하시겠습니까?', '', {
      }).then(() => {
        let param = {}
        param.cate_code = codeCode
        param.parent_code = parentCode
        param.is_leaf = isLeaf
        common.axios.delete('/category', {data: param})
          .then(response => {
            this.$message('삭제되었습니다.')
            this.search.cate_code = ''
            this.getParentList()
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    },
    handleChange (value) {
      this.search.cate_code = value[value.length - 1]
    },
    getParentList () {
      common.axios.get('/category/tree')
        .then(response => {
          this.options = [{
            children: response.data,
            label: 'ALL',
            parent: '',
            seq: '',
            value: ''
          }]
          this.retrieve()
        })
    },
    selectedTree () {
      // console.log(this.$refs.tree.getCheckedNodes())
      // console.log(this.$refs.tree.getCheckedKeys())
      // console.log(this.$refs.tree.getCurrentNode())
    },
    handleNodeClick (data) {
      // console.log('handleNodeClick : ', data)
    },
    goEditTree (data) {
      const param = {
        cate_code: data.value
      }
      this.$router.push({name: 'M990402', params: param})
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/M990401.vue